import type { CookieService } from "@/src/infrastructure/cookieconsent/CookieService";

import { CookieCategory } from "@/src/infrastructure/cookieconsent/CookieCategory";

export const airtableEmbedOrigin = "https://airtable.com";

export const airtableCookie: CookieService<CookieCategory.FEATURES> = {
  category: CookieCategory.FEATURES,
  iframe: {
    embedUrl: `${airtableEmbedOrigin}/embed/{data-id}`,
    label:
      "Pour voir ce contenu (formulaire d’inscription, liste d’évènements…)",
  },
  name: "Airtable",
  privacyPolicyUrl: "https://www.airtable.com/company/privacy",
  purpose: "Contenus, images et formulaires",
};
